var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.842 1.667a1.042 1.042 0 0 0 0 2.083h.702c.197 0 .368.139.408.332.186.891.713 3.384 1.135 5.085a58 58 0 0 0 1.294 4.502 2.501 2.501 0 0 1 3.594 1.286c.623.028 1.35.045 2.195.045.715 0 1.333-.012 1.868-.033a2.5 2.5 0 0 1 3.611-1.29c.294-.741.69-1.982 1.026-3.885.24-1.365.389-2.39.48-3.133C19.267 5.745 18.554 5 17.633 5H6.383l-.517-2.07a1.67 1.67 0 0 0-1.617-1.263z",
    opacity: 0.32
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.625 8.829a.83.83 0 1 0-1.65-.165l-.25 2.508a.83.83 0 1 0 1.65.165zM10.625 8.664a.83.83 0 1 0-1.65.165l.25 2.508a.83.83 0 1 0 1.65-.165zM13.884 15.833a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0M5.134 15.833a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0"
  })));
};
export default SvgCart;